import {helpers} from 'vuelidate/lib/validators'

// validator for dates of the form YYYY-MM-DD
export const date = helpers.regex ('date', /^[0-9]{4}-[0-1]?[0-9]-[0-3][0-9]$/)
